module.exports = __webpack_public_path__ + "img/c.72e8de27.svg";